import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-legajos-index',
  templateUrl: './legajos-index.component.html',
  styleUrl: './legajos-index.component.scss'
})
export class LegajosIndexComponent {
  
  TipoUsuario = TipoUsuario;

  constructor(private authService: AuthService ) {
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
